const state = {
  role: [],
};

const mutations = {
  setRole(state, roles) {
    state.role = roles;
  },
};

const actions = {
  updateRole({ commit }, roles) {
    commit("setRole", roles);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
